import { GenericReportingDropdowns } from '../../containers/GenericReportingDropdowns';
import InfluencerOutreachPage from '../../containers/Influencer/InfluencerOutreachPage';
import PageLayout from '../UI/PageLayout';

export default function OutreachPage() {
    return (
        <PageLayout
            title='Outreach'
            dropdowns={<GenericReportingDropdowns includeDateRange={true} includeRegion={false}
                includeTooltipsAndTitles={false} containerStyle='dropdown-container'
                renderAsButton={true} includeCompareDateRange={true} />}
            content={<InfluencerOutreachPage />} />
    );
}